import type { Feature, FeatureModule } from '../../../../types';
import { featureList } from '../../../helpers';
import { DEVELOPMENT_DATA_IMPORTS_FEATURE_GROUP } from './group';

export const DEVELOPMENT_DATA_IMPORTS_FEATURES = {
  ACCESS: {
    guid: '715a49f2-85e3-4ec3-a3eb-76c652040001',
    name: 'development:data-imports:access',
    description: 'Access the Data Imports development tool',
    action: 'read',
    product: 'app',
    parentGuid: DEVELOPMENT_DATA_IMPORTS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { DEVELOPMENT_DATA_IMPORTS_FEATURE_GROUP } from './group';

export const DEVELOPMENT_DATA_IMPORTS_MODULE: FeatureModule = {
  product: 'app',
  groups: [DEVELOPMENT_DATA_IMPORTS_FEATURE_GROUP],
  features: featureList(DEVELOPMENT_DATA_IMPORTS_FEATURES),
};
